import { FC, useState } from "react";
import {
  Alert,
  Card,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  styled,
} from "@mui/material";
import { RedFlagQuestion } from "../types";

const RedFlagContainer = styled(Card)({
  padding: "1rem",
});

interface RedFlagCardProps {
  index: number;
  redFlag: RedFlagQuestion;
}

const RedFlagCard: FC<RedFlagCardProps> = ({
  index,
  redFlag: { question, consideration, additionalInfo },
}) => {
  const [answer, setAnswer] = useState("");

  return (
    <RedFlagContainer variant="outlined">
      <FormControl>
        <FormLabel id={`radio-buttons-red-flag-${index}-label`}>
          {index}. {question}
        </FormLabel>
        <FormHelperText>{additionalInfo}</FormHelperText>
        <RadioGroup
          row
          aria-labelledby={`radio-buttons-red-flag-${index}-label`}
          value={answer}
          name={`radio-buttons-red-flag-${index}`}
          onChange={(e) => setAnswer(e.target.value)}
        >
          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="no" control={<Radio />} label="No" />
        </RadioGroup>
      </FormControl>
      {answer === "yes" && <Alert severity="error">{consideration}</Alert>}
    </RedFlagContainer>
  );
};

export default RedFlagCard;
